import { useParams } from 'react-router-dom';

export default function useCurrentRequestLogId(): string | null {
  const { requestLogId } = useParams<{ requestLogId: string | undefined }>();
  return requestLogId ?? null;
}
